export default "__VITE_ASSET__DoMPlT7O__"